import moment from "moment-timezone";

import Tls from "@/services/Tls";

import GroupMap 					from "@/components/Group/Map";
import TlsCasesList 			from "@/components/TlsCase/List";
import GroupIframe 				from "@/components/Group/Iframe";
import NewCase 						from "@/components/Group/NewCase";
import GroupInstructions 	from "@/components/Group/Instructions";

// ==================
// NAME
// ==================
const name = "GroupShow";

// ================
// DATA
// ================
const data = function () {
	return {
		group: null,
		pros: [],
		groupCurrentTime: null,
		tlsCases: [],
		loading: "none",
	};
};

// =================
// METHODS
// =================
const fetchGroup = function () {
	const { groupId } = this.$route.params;

	Tls.Groups.find(groupId).then(response => {
		if (response.group) {
			this.group = response.group;

			this.$store.commit("addGroup", response.group);
		}
	});
};

const fetchGroupPros = function () {
	const { groupId } = this.$route.params;

	Tls.Groups.getPros(groupId).then(response => {
		this.pros = response.pros;
	});
};

const fetchCases = function () {
	const { groupId } = this.$route.params;

	Tls.Cases.all({ groupId }).then(response => {
		if (response.cases) {
			this.tlsCases = response.cases;
		}
	});
};

const updateTime = function () {
	setInterval(() => {
		if (this.group && this.group.tzinfo) {
			const tz = this.group.tzinfo.identifier;
  
			this.groupCurrentTime = moment().tz(tz).format("DD/MM/YYYY HH:mm:ss");
		}
	}, 1000);
};

const removeCaseFromList = function (tlsCase) {
	const data    = Object.assign([], this.tlsCases);
	this.tlsCases = data.filter(c => c != tlsCase);
};

const fetchData = function () {
	updateTime.bind(this)();
	fetchGroup.bind(this)();
	fetchCases.bind(this)();
	fetchGroupPros.bind(this)();
};

export default {
	name,
	data,

	mounted() {
		this.fetchData();
	},

	watch: {
		"$route": "fetchData"
	},

	components: {
		TlsCasesList,
		GroupMap,
		GroupInstructions,
		NewCase,
		GroupIframe
	},

	methods: {
		fetchData,
		fetchCases,
		removeCaseFromList
	},

 	computed: {
 		groupUrl: function () {
			let url = new URL(this.group.urlname, process.env.VUE_APP_PRO_URL);

			url.searchParams.set("popin", "1");
			url.searchParams.set("token_telesecretariat", this.$store.state.token);

			return url.toString();
		}
	}
};